// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__9-82q","text":"SelectPayment_text__10FnN","title":"SelectPayment_title__3U3eD","btn":"SelectPayment_btn__2H6rR"};